import styled from 'styled-components'

export const StyledTextWrapper = styled.div`
  margin-bottom: 2rem;
`

export const StyledBankListWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
`

export const StyledAlertWrapper = styled.div`
  margin-top: 1rem;
`

export const textStyles = {
  title: { fontSize: 20 },
  description: { fontSize: 14 },
  link: { color: '#000' },
  margin: { marginBottom: '40px', marginTop: '20px', fontSize: 14 },
};